import { MultiPledgeRadioWithCurrencyComponent } from "../util/amount/multiPledgeRadioWithCurrencyComponent";
import { PledgeCurrencyAmount } from "../util/amount/pledgeRadio";
import { DonationForm } from "../util/donation/donationForm";
import { StripePaymentElement } from "../util/stripe/stripePaymentElement";
import { getMeta } from "../util/helpers";
import { showErrorWithMessage, hideErrors } from "../util/payment/paymentForm";
import { fcbhCredentials, getPaymentProcessorURL, redirectByResponse, getRedirectUrlByStatusAndOutreach } from "../util/payment";
import { initializeLanguageSettings } from "../util/internationalization";
import isEmpty from 'lodash/isEmpty';

let undesignedDonation = '';
let captchaWidgetId;
let isCreditCardSelected = false;

let defaultCurrency = getMeta("default_currency") ?? "SGD";
AddMetaTag();
addOtherAmountStyle();

// Mapping pledge form elements
let pledgeFormMap = {
  formSelector: "form#wf-form-Unchained-Singapore-Bank",
  paymentTabSelector: ".method-selector_toggle.is-active",
  ccDonationTextSelector: "#donation-text",
  paypalDonationTextSelector: "#donation-text-paypal",
  customerTypeCheckboxId: "Give-CustomerType",
  companyInputWrapperId: "company-input-wrapper",
  companyInputId: "Give-Company",
  errorBlockSelector: "._w-form-fail-bank.w-form-fail",
  outreach: getMeta('outreach') || "FCBH-ASIA",
  defaultCurrency: getMeta('default_currency') || "SGD",
  defaultCountry: getMeta('default_country') || "SG",
  captcha: true,
  captchaId: "captcha"
};

let pOtherAmountElMap = {
  inputId: "other-quantity-obt",
  suffixId: "other-qty-currency-bank",
  initialValue: 30,
  sufixClass: "currency-sufix-2"
};

let currencySelectorEl = { selectCurrencyId: "Currency-Bank" };

let pAmountElMap = {
  handleOtherAmountEl: pOtherAmountElMap,
  pledgeRadioEl: {
    handlesContainerSelector: "#amount-container-bank",
    amountRadioNames: "OBT",
    elementValueIndex: '2',
    labelSelector: ".radio_value.w-form-label"
  }
};

let otherAmountElMap = {
  inputId: document.getElementById("other-quantity-blp") ? "other-quantity-blp" : "other-quantity-blt",
  suffixId: "other-qty-currency",
  initialValue: 30,
  sufixClass: "currency-sufix-2"
};

let amountElMap = {
  handleOtherAmountEl: otherAmountElMap,
  pledgeRadioEl: {
    handlesContainerSelector: "#amount-container-blp",
    amountRadioNames: "BLP",
    elementValueIndex: '2',
    labelSelector: ".radio_value.w-form-label"
  }
};

let obtAmountElMap;
let blpAmountElMap;

window.addEventListener("pageshow", () => {
  FCBH.docReady(async () => {
    // Ensure form has novalidate attribute so HTML5 validation doesn't block unselected groups
    const formEl = document.querySelector(pledgeFormMap.formSelector);
    if (formEl) formEl.setAttribute("novalidate", "novalidate");

    // Fix duplicate amount-container-bank in Webflow HTML for BLP container dynamically
    const blpRadios = document.querySelectorAll('input[name="BLP"]');
    if (blpRadios.length > 0) {
      const blpContainer = blpRadios[0].closest('.full-col__input-wrapper');
      if (blpContainer && !document.getElementById('amount-container-blp')) {
        blpContainer.id = 'amount-container-blp';
      }
    }

    // Support both other-quantity-blp and other-quantity-blt
    otherAmountElMap.inputId = document.getElementById("other-quantity-blp") ? "other-quantity-blp" : "other-quantity-blt";

    obtAmountElMap = new PledgeCurrencyAmount(pAmountElMap.handleOtherAmountEl, pAmountElMap.pledgeRadioEl, "Currency-Bank");
    blpAmountElMap = new PledgeCurrencyAmount(amountElMap.handleOtherAmountEl, amountElMap.pledgeRadioEl, "Currency-Bank");

    const translations = await initializeLanguageSettings();
    onloadCallback();

    pledgeFormMap = { ...pledgeFormMap, captchaWidgetId: captchaWidgetId };

    const formPledge = new DonationForm(pledgeFormMap, translations);

    const formPayment = {
      firstNameElId: "Give-FirstName",
      lastNameElId: "Give-LastName",
      address1ElId: "Give-Address",
      address2ElId: "Give-Address-2",
      cityElId: "Give-city",
      stateElId: "Give-State",
      regionElId: "Give-Region",
      zipElId: "Give-Zip",
      countryElId: "Give-Country",
      emailElId: "Give-Email",
      phoneNumberElId: "Give-Phone-Number",
    };
    let stripePaymentElement = new StripePaymentElement(formPledge, formPayment);

    init(stripePaymentElement, formPledge);
  });
});

function onloadCallback() {
  const globalCaptcha = document.getElementById('captcha');
  globalCaptcha?.classList.add("w-form-formrecaptcha", "g-recaptcha", "g-recaptcha-error", "g-recaptcha-disabled");

  const siteKey = "6LdZQtsrAAAAAKuAcVprVnSdCzuzf1FFMV2cFVcR";
  const options = {
    sitekey: siteKey,
    theme: 'light'
  };
  if (typeof grecaptcha !== "undefined" && grecaptcha.render && document.getElementById('captcha')) {
    try {
      captchaWidgetId = grecaptcha.render('captcha', options);
    } catch (e) {
      console.warn("reCAPTCHA already rendered or failed to render:", e);
    }
  }
}

function AddMetaTag() {
  const meta = document.createElement("meta");
  meta.name = "donationMessage";
  meta.content = "to give God's Word";
  document.head.append(meta);

  const rsMeta = document.createElement("meta");
  rsMeta.name = "returnSite";
  rsMeta.content = "fcbh_asia";
  document.head.append(rsMeta);

  let metaOutreach = document.querySelector("meta[name='outreach']");
  if (metaOutreach && metaOutreach.content) {
    metaOutreach.setAttribute("content", "FCBH_ASIA");
  }
}

function createCCSectionStyles(formPledge) {
  const container = document.querySelector("#give-credit-card.method-card") || document.querySelector(".method-card");
  const bankNotice = document.querySelector(".method-bank > .mb-16");
  const methodBank = document.getElementById("method_bank");
  const methodCard = document.getElementById("method_card");

  if (container) {
    container.style.display = "none";
  }

  const toggleTo = (method) => {
    if (method === "credit card") {
      if (container) container.style.display = "block";
      if (bankNotice) bankNotice.style.display = "none";
      if (methodCard) methodCard.classList.add("is-active");
      if (methodBank) methodBank.classList.remove("is-active");
      isCreditCardSelected = true;
    } else {
      if (container) container.style.display = "none";
      if (bankNotice) bankNotice.style.display = "block";
      if (methodBank) methodBank.classList.add("is-active");
      if (methodCard) methodCard.classList.remove("is-active");
      isCreditCardSelected = false;
    }
    formPledge?.updateDonationText(formPledge.getStorage());
  };

  if (methodBank) {
    methodBank.addEventListener("click", () => toggleTo("bank transfer"));
  }
  if (methodCard) {
    methodCard.addEventListener("click", () => toggleTo("credit card"));
  }

  // Also bind any generic method-selector_toggle divs
  for (const node of document.querySelectorAll("div.method-selector_toggle")) {
    const text = node.textContent.trim().toLowerCase();
    node.addEventListener("click", () => toggleTo(text));
  }
}

function addOtherAmountStyle() {
  const styleElement = document.createElement('style');
  const cssRules = `
      .currency-sufix-2 {
        position: relative;
        top: -35px;
        color: #849cb5;
        left: 10px;
      }
    @media only screen and (min-width: 1920px) {
      .currency-sufix-2 {
        top: -24px;
      } 
    }

    @media only screen and (max-width: 991px) {
      .currency-sufix-2 {
        top: -35px;
      } 
    }
  `;
  styleElement.textContent = cssRules;
  document.head.appendChild(styleElement);
  
  document.getElementById('other-qty-currency')?.classList.add('currency-sufix-2');
  document.getElementById('other-qty-currency-bank')?.classList.add('currency-sufix-2');
  document.getElementById('other-qty-currency')?.classList.remove('currency-sufix');
  document.getElementById('other-qty-currency-bank')?.classList.remove('currency-sufix');
}

function init(stripePaymentElement, formPledge) {
  const formCampaign = formPledge.formCampaign;

  createCCSectionStyles(formPledge);
  
    //obtAmountElMap = new PledgeCurrencyAmount(pAmountElMap.handleOtherAmountEl, pAmountElMap.pledgeRadioEl, "Currency-Bank");
    //blpAmountElMap = new PledgeCurrencyAmount(amountElMap.handleOtherAmountEl, amountElMap.pledgeRadioEl, "Currency-Bank");

  const bankPledgeRadioWithCurrencyComponent = new MultiPledgeRadioWithCurrencyComponent(
    formPledge,
    currencySelectorEl,
    [pAmountElMap, amountElMap],
    defaultCurrency,
    stripePaymentElement
  );

  createFormCallbacks();

  function getAmount() {
    return formPledge.getStorage()?.amounts?.usdValue;
  }
  
  function getLocalAmount() {
    return formPledge.getStorage()?.amounts?.value;
  }

  function createFormCallbacks() {
    formPledge.onFormSubmit = async (event) => await submitEvent(event);
    formPledge.validateForm = async (event) => await validateEvent(event);
  }
  
  async function validateEvent(event) {
    if (isCreditCardSelected) {
      return await validateForm(event);
    } else {
      return await validatePledge(event);
    }
  }

  
  async function submitEvent(event) {
    if (isCreditCardSelected) {
      return await onFormSubmit(event);
    } else {
      return await onPledgeSubmit(event);
    }
  }

  function mapFormFields() {
    const formattedDonationTotal = `${formPledge.getStorage()?.currency_code === "USD" ? "$" : `${formPledge.getStorage()?.currency_code} `}${formPledge.getStorage()?.amounts?.value}`;
    const pledgeMsg = isEmpty(formPledge.getStorage()?.pledge_message) ? "" : formPledge.getStorage()?.pledge_message;
    const formData = new FormData(formPledge.form);

    const spouse_first_name = (formData.get("Spouse-First-Name") || formData.get("Spouse-FirstName") || "").trim();
    const spouse_last_name = (formData.get("Spouse-Last-Name") || formData.get("Spouse-LastName") || "").trim();
    
    const hiddenFundCode = document.getElementById("project-fund-code")?.value;
    const fundCode = hiddenFundCode || getMeta('project_fund_code') || formPledge.getStorage()?.project_fund_code || "ASIA2033-Q";

    const isBusiness = Boolean(formData.get('Give-Customer-Type') || formData.get('Give-CustomerType') || document.getElementById('Give-CustomerType')?.checked);
    const companyName = (formData.get('Give-Company') || "").trim();
    const phoneVal = (formData.get("Give-Phone-Number") || "").replace(/\s/g, '').slice(-10);

    const formStruct = {
      cssid: "3u8kfk8rej7cvflqqkskura2nt",
      ...formPledge.getPrograms(),
      campaign: formCampaign.campaign,
      outreach: formPledge.outreach,
      return_site: isEmpty(getMeta('returnSite')) ? "fcbh_asia" : getMeta('returnSite'),
      undesignated_donation: "",
      amount: `$${getLocalAmount()}`,
      usd_amount: parseFloat(getAmount() || 0).toFixed(2),
      formatted_donation_total: formattedDonationTotal,
      currency_code: formPledge.getStorage()?.currency_code || defaultCurrency,
      recurring_donation: formPledge.getStorage()?.recurring_donation ?? "no",
      first_name: `${formData.get("Give-FirstName") || ""}`.trim(),
      last_name: `${formData.get("Give-LastName") || ""}`.trim(),
      address_street: formData.get("Give-Address1") || formData.get("Give-Address") || "",
      address_street_2: formData.get("Give-Address2") || formData.get("Give-Address-2") || "",
      address_country: formData.get("Give-Country") || "",
      address_city: formData.get("Give-city") || "",
      address_region: formData.get("Give-Region") || "",
      address_state: formData.get("Give-Country") === "US" ? formData.get("Give-State") : (formData.get("Give-Region") || formData.get("Give-State") || ""),
      address_zip: formData.get("Give-Zip") || "",
      phone: phoneVal,
      email: (formData.get("Give-Email") || "").trim(),
      donation_message: formData.get("Give-Message") || "",
      name: `${formData.get("Give-FirstName") || ""} ${formData.get("Give-LastName") || ""}`.trim(),
      spouse_first_name,
      spouse_last_name,
      spouse_name: `${spouse_first_name} ${spouse_last_name}`.trim(),
      customer_type: isBusiness ? 'Business' : 'Individual',
      customer_type_value: isBusiness ? 'true' : '',
      company_name: companyName,
      project_fund_code: fundCode,
      successful_url: `${window.location.origin}${getRedirectUrlByStatusAndOutreach("success", formPledge.outreach)}`,
      cancel_url: `${window.location.origin}${getRedirectUrlByStatusAndOutreach("error", formPledge.outreach)}`,
      ui_mode: 'custom',  
      pledge_message: pledgeMsg,
    };
    return formStruct;
  }

  function validateProgramAndAmount(usdAmount, localAmount) {
    const errors = [];
    const selectedPrograms = formPledge.getStorage()?.selected_programs || [];
    if ((selectedPrograms.length === 0 || !selectedPrograms.length) && localAmount <= 0) {
      errors.push("The donor must select at least one program to donate.");
    } else if (usdAmount <= 10) {
      errors.push("The total amount must be greater than 10 dollars.");
    }
    return errors;
  }

  function validateCaptcha() {
    const cresponse = (captchaWidgetId !== undefined && captchaWidgetId !== "")
      ? grecaptcha.getResponse(captchaWidgetId)
      : (typeof grecaptcha !== "undefined" ? grecaptcha.getResponse() : "");
    if (!cresponse || cresponse.length === 0) {
      return ["Please complete the reCAPTCHA challenge."];
    }
    return [];
  }

  async function validateForm(event) {
    const formStruct = mapFormFields();
    const usdAmount = parseFloat(formStruct.usd_amount || 0);
    const localAmount = parseFloat(getLocalAmount() || 0);

    const errors = [
      ...validateProgramAndAmount(usdAmount, localAmount)
    ];

    const requiredFields = [
      "first_name",
      "last_name",
      "address_street",
      "address_city",
      "address_country",
      "address_zip",
      "phone",
      "email",
    ];
    const fieldLabels = [
      "First Name",
      "Last Name",
      "Address 1",
      "City",
      "Country",
      "Zip Code",
      "Phone Number",
      "Email",
    ];

    requiredFields.forEach((field, index) => {
      if (!formStruct[field] || String(formStruct[field]).trim() === "") {
        errors.push(`${fieldLabels[index]} is required.`);
      }
    });

    const nameRegex = /^(['À-ÿa-zA-Z\/\s])*$/;
    if (formStruct.first_name && !nameRegex.test(formStruct.first_name)) {
      errors.push("First Name can only be letters.");
    }
    if (formStruct.last_name && !nameRegex.test(formStruct.last_name)) {
      errors.push("Last Name can only be letters.");
    }

    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (formStruct.email && !emailRegex.test(formStruct.email)) {
      errors.push("Email is not valid.");
    }

    if (formStruct.customer_type === "Business" && (!formStruct.company_name || formStruct.company_name.length < 3)) {
      errors.push("Company Name or Organization Name must have at least 3 characters.");
    }

    errors.push(...validateCaptcha());

    if (errors.length > 0) {
      showErrorWithMessage(formPledge.errorBlockEl, errors);
      event?.preventDefault();
      return false;
    }

    hideErrors(formPledge.errorBlockSelector);
    return true;
  }

  async function onFormSubmit(event) {
    event?.preventDefault();
    const isValid = await validateForm(event);
    if (!isValid) return;
    const formStruct = mapFormFields();
    await stripePaymentElement.processStripePayment(formStruct);
  }

  function mapPledgeFormFields() {
    const formattedDonationTotal = `${formPledge.getStorage()?.currency_code === "USD" ? "$" : `${formPledge.getStorage()?.currency_code} `}${formPledge.getStorage()?.amounts?.value}`;
    const formData = new FormData(formPledge.form);
    const pledgeMsg = isEmpty(formPledge.getStorage()?.pledge_message) ? "" : formPledge.getStorage()?.pledge_message;
    const phoneVal = (formData.get("Give-Phone-Number") || "").replace(/\s/g, '').slice(-10);
    const spouse_first_name = (formData.get("Spouse-First-Name") || formData.get("Spouse-FirstName") || "").trim();
    const spouse_last_name = (formData.get("Spouse-Last-Name") || formData.get("Spouse-LastName") || "").trim();
    const companyName = (formData.get('Give-Company') || "").trim();

    const obj = {
      ...formPledge.getPrograms(),
      campaign: formCampaign.campaign,
      outreach: formPledge.outreach,
      return_site: isEmpty(getMeta('returnSite')) ? "fcbh_asia" : getMeta('returnSite'),
      undesignated_donation: undesignedDonation,
      amount: `$${getLocalAmount()}`,
      usd_amount: parseFloat(getAmount() || 0).toFixed(2),
      formatted_donation_total: formattedDonationTotal,
      currency_code: formPledge.getStorage()?.currency_code || defaultCurrency,
      first_name: `${formData.get("Give-FirstName") || ""}`.trim(),
      last_name: `${formData.get("Give-LastName") || ""}`.trim(),
      spouse_first_name,
      spouse_last_name,
      spouse_name: `${spouse_first_name} ${spouse_last_name}`.trim(),
      company_name: companyName,
      phone: phoneVal,
      email: (formData.get("Give-Email") || "").trim(),
      recurring_donation: formPledge.getStorage()?.recurring_donation ?? "no",
      pledge_message: pledgeMsg
    };
    return obj;
  }
  
  async function validatePledge(event) {
    const formStruct = mapPledgeFormFields();
    const usdAmount = parseFloat(formStruct.usd_amount || 0);
    const localAmount = parseFloat(getLocalAmount() || 0);

    const errors = [
      ...validateProgramAndAmount(usdAmount, localAmount)
    ];

    const requiredFields = [
      "first_name",
      "last_name",
      "phone",
      "email",
    ];
    const fieldLabels = [
      "First Name",
      "Last Name",
      "Phone Number",
      "Email",
    ];

    requiredFields.forEach((field, index) => {
      if (!formStruct[field] || String(formStruct[field]).trim() === "") {
        errors.push(`${fieldLabels[index]} is required.`);
      }
    });

    const nameRegex = /^(['À-ÿa-zA-Z\/\s])*$/;
    if (formStruct.first_name && !nameRegex.test(formStruct.first_name)) {
      errors.push("First Name can only be letters.");
    }
    if (formStruct.last_name && !nameRegex.test(formStruct.last_name)) {
      errors.push("Last Name can only be letters.");
    }

    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (formStruct.email && !emailRegex.test(formStruct.email)) {
      errors.push("Email is not valid.");
    }

    errors.push(...validateCaptcha());

    if (errors.length > 0) {
      showErrorWithMessage(formPledge.errorBlockEl, errors);
      event?.preventDefault();
      return false;
    }

    hideErrors(formPledge.errorBlockSelector);
    return true;
  }

  async function onPledgeSubmit(event) {
    event?.preventDefault();
    const isValid = await validatePledge(event);
    if (!isValid) return;

    const errorBlockEl = formPledge.errorBlockEl;
    const formStruct = mapPledgeFormFields();
    try {
      
      var apiKey = await fcbhCredentials();
      const formToSend = new FormData();
      for (const key in formStruct) {
        if (formStruct[key] !== undefined && formStruct[key] !== null) {
          formToSend.append(key, formStruct[key]);
        }
      } 
  
      const response = await FCBH.axiosInstance.post(
        getPaymentProcessorURL("pledge"),
        formToSend,
        apiKey
      );
      redirectByResponse(response, formPledge.responseParams, formPledge.formCampaign.localForm);
  
    } catch (err) {
      console.error(err);
      const response = { data: err.responseText };
      if (response.data?.includes("status")) {
        redirectByResponse(response, formPledge.responseParams, formPledge.formCampaign.localForm);
      } else {
        showErrorWithMessage(errorBlockEl, "An error occurred while sending the form, please try again later.");
      }
    }
  }
}
